module.exports = __webpack_public_path__ + "static/media/GR.46a76c71.webp";